<template>
  <main>
    <Navbar />
    <div class="container">
      <div class="login">
        <h1>Área Restrita</h1>
        <p v-if="loadingAccessKey" class="acesso-msg">Entrando…</p>
        <form v-else @submit.prevent="logar">
          <div class="form-group">
            <label for="text">Login:</label>
            <input v-model="user.username" type="text" id="text" autocomplete="username" required>
          </div>
          <div class="form-group">
            <label  for="password">Senha:</label>
            <input v-model="user.password" type="password" id="password" autocomplete="current-password" required>
          </div>
          <button type="submit">Entrar</button>
        </form>
      </div>
    </div>
    <Footer />
  </main>
</template>

<script>
import Footer from '@/components/landingpage/Footer.vue'
import Navbar from '@/components/landingpage/adm/Navbar.vue';
// import authService from '@/services/auth.service';
import { useToast } from "vue-toastification"
const toast = useToast()
export default {
  components: {
    Footer,
    Navbar
  },
  data() {
    return {
      alert_msg: false,
      msg_dialog: '',
      user: {
        username: '',
        password: ''
      },
      loadingAccessKey: false,
    }
  },
  mounted() {
    this.tentarLoginPorToken();
  },
  watch: {
    '$route.query': {
      handler() {
        this.tentarLoginPorToken();
      },
      deep: true,
    },
  },
  methods: {
    tentarLoginPorToken() {
      const raw = this.$route.query.loginToken ?? this.$route.query.token;
      const token = typeof raw === 'string' ? raw.trim() : '';
      if (!token) return;
      if (this.loadingAccessKey) return;
      this.loadingAccessKey = true;
      this.$store
        .dispatch('auth/loginAccessKey', token)
        .then((response) => {
          const ok =
            response.status === 200 &&
            response.data &&
            (response.data.accessToken || response.data.token);
          if (ok) {
            this.$router.replace({ path: '/admin/despedidas' });
          } else {
            toast.error('Não foi possível entrar com este link.');
            this.loadingAccessKey = false;
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            toast.error('Link inválido ou expirado.');
          } else {
            toast.error('Falha na conexão com o servidor!');
            console.error(error);
          }
          this.loadingAccessKey = false;
        });
    },
    logar() {
      if (this.user.username && this.user.password) {
        this.$store.dispatch('auth/loginLDAP', this.user)
          .then(
            (response) => {
              const ok =
                response.status === 200 &&
                response.data &&
                (response.data.accessToken || response.data.token);
              if (ok) {
                this.$router.push({ path: '/admin/despedidas' });
              } else {
                toast.error('Erro ao logar!');
              }
            }
          ).catch(error => {
            if (error.response && error.response.status === 401) {
              toast.error('Usuário ou senha não confere');
            } else {
              toast.error('Falha na conexão com o servidor!');
              console.error(error);
            }
          });
      }
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@100..800&display=swap');

* {
  margin: 0;
  padding: 0;
  font-family: "Sora", sans-serif;
}

main {
  background-image: url('@/assets/images/Elementos/fundo.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

.container {
  min-height: 70vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

.text {
  color: #FFFFFF;
}

.crie {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 4rem;
}

.text p {
  font-size: 31px;
  font-weight: 300;
}

.text h1 {
  font-size: 86px;
  font-weight: 800;
  line-height: 5rem;
  text-align: center;
}

.login {
  display: flex;
  flex-direction: column;
  background-color: #343F53;
  padding: 1rem 2.6rem;
  border-radius: 9px;
  color: #FFFFFF;
  align-items: center;
  text-align: center;
}

.login h1 {
  min-width: 19rem;
  font-size: 37px;
  font-weight: 800;
}

.acesso-msg {
  margin-top: 1rem;
  font-size: 1.1rem;
  font-weight: 400;
}

.login input {
  margin-top: 0.8rem;
  border: none;
  padding: 0.2rem;
  border-radius: 6px;
  min-width: 14em;
  background-color: #fff;
}

.form-group {
  display: flex;
  align-items: center;
}

.form-group label {
  margin-right: 0.5rem;
  margin-top: 0.8rem;
  min-width: 5.5rem;
  font-size: 25px;
  font-weight: 300;
}

.reset {
  margin-top: 0.8rem;
  text-decoration: none;
  color: #FFFFFF;
  font-size: 15px;
  font-weight: 100;
  text-align: center;
  transition: 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login button {
  margin-top: 0.8rem;
  padding: 0.2rem 0;
  color: #343F53;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  width: 80%;
  background-color: #fff;
}

.login button:hover,
.login a:hover {
  opacity: 0.5;
}

@media (max-width: 1037px) {
  .container {
    flex-direction: column;
  }

  .text h1 {
    font-size: 50px;
    line-height: 2.5rem;
  }

  .login {
    padding: 1rem 1.5rem;
  }
}
</style>
